import i18n from "i18next";

export function columnsUserManagement() {
  return [
    {
      id: "email",
      label: i18n.t("general.email_capital"),
      minWidth: 100,
      maxWidth: 120,
      align: "left",
    },
    {
      id: "first_name",
      label: i18n.t("person.first_name"),
      minWidth: 60,
      maxWidth: 110,
      align: "left",
    },
    {
      id: "last_name",
      label: i18n.t("person.last_name"),
      minWidth: 60,
      maxWidth: 110,
      align: "left",
    },
    {
      id: "phone",
      label: i18n.t("general.phone"),
      minWidth: 80,
      maxWidth: 100,
      align: "left",
    },
    {
      id: "is_manager",
      label: i18n.t("column.user_status"),
      minWidth: 80,
      maxWidth: 100,
      align: "left",
    },
  ];
}
